/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    compact: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    compact: false,
    componentClass: 'ul',
};

const ListItem = (props) => {
    const classNames = [
        'c-list',
        props.compact ? 'c-list--compact' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

ListItem.propTypes = propTypes;

ListItem.defaultProps = defaultProps;

export default ListItem;
